import React from 'react'
import { Center, Divider, Text, Box, Container, HStack, SimpleGrid, Card, Image, Stack, CardBody, Tag } from '@chakra-ui/react';
export default function Experience() {

  const experienceCardGetter = (companyLogo, companyName, jobType, jobRole, jobTimeline, jobDesc) => (
    <Card
      direction={"row"}
      overflow='hidden'
      variant='outline'
    >
      <Stack>
        <CardBody>
          <HStack>
            <Image
              objectFit='cover'
              height={12}
              src={companyLogo}
              alt='company logo'
              className='company_logo'
            />
            <Box>
              <Text fontSize={"lg"}>{companyName}</Text>
              <Tag colorScheme='blue' fontWeight={"thin"} mt={1}>{jobType}</Tag>
            </Box>
          </HStack>
          <Text py='1' fontSize={"sm"}>
            {jobRole}
          </Text>
          <Text fontSize={"sm"} color={"gray.400"}>
            {jobTimeline}
          </Text>
          <Text fontSize={"sm"} mt={2}>
            {jobDesc}
          </Text>
        </CardBody>
      </Stack>
    </Card>
  )

  return (
    <div data-aos="fade-up">
      <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
        <Center height='50px' mt={3}>
          <Divider orientation='vertical' className='vertical_divider' />
        </Center>
        <Text fontSize={"2xl"}
          bgGradient='linear(to-l,#2193b0, #6dd5ed)'
          bgClip='text'
          fontWeight={"semibold"}
        >
          Experience
        </Text>
      </Box>
      <Container mt={3}>
        <SimpleGrid columns={1} spacing={3}>
          {experienceCardGetter("https://yt3.ggpht.com/ytc/AMLnZu-Nuz9TJ_Pf__lJv8viVBBmACEvJGw08mHbNNzzHA=s900-c-k-c0x00ffffff-no-rj", "CME Group", "Intern",
            "Software Developer Engineer (Full Stack)", "Jan 2023 - ",
            "Javascript, React.js, MongoDB, Node.js (Express)")}
          {experienceCardGetter("https://play-lh.googleusercontent.com/vdrioE2gDTvUBHLMC-c5-VvcueLvhaxULLBZSjubiQgZtzKmqsPHKPilxW4TfUfuQxE", "Highradius Corporation", "Intern",
            "Software Developer Engineer (Frontend)", "Jun 2022 - Nov 2022",
            "React.js, Redux.js (Saga), Axios, Web Services API, Voice over IP (VoIP), Session Initiation Protocol (SIP), Peer Testing, Git, Jira, PuTTY")}
          {experienceCardGetter("https://moodyhuez.in/wp-content/uploads/2021/12/cropped-logo_removed_bg-2.png", "Moodyhuez", "Part-time",
            "Ecommerce Developer", "Sep 2020 - Dec 2020",
            "Bootstrap, PHP, SQL, WordPress")}
        </SimpleGrid>
      </Container>
    </div>
  )
}
